import React, { useState, useEffect } from 'react';

const DashboardOverview = () => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const savedOrders = localStorage.getItem('orders');
    if (savedOrders) {
      const parsedOrders = JSON.parse(savedOrders, (key, value) => {
        if (key === 'orderedAt') return new Date(value);
        return value;
      });
      setOrders(parsedOrders);
    }
  }, []);

  // Calculate today's date for filtering
  const today = new Date();
  const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  // Calculate stats
  const totalOrdersToday = orders.filter(order => 
    new Date(order.orderedAt) >= startOfDay
  ).length;

  const revenueToday = orders
    .filter(order => new Date(order.orderedAt) >= startOfDay)
    .reduce((sum, order) => sum + parseFloat(order.total), 0)
    .toFixed(2);

  const stats = [
    { name: 'Total Orders Today', value: totalOrdersToday },
    { name: 'Revenue Today', value: `$${revenueToday}` },
  ];

  // Get recent orders (last 5)
  const recentOrders = [...orders]
    .sort((a, b) => b.orderedAt - a.orderedAt)
    .slice(0, 5);

  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-gold-dark">Dashboard Overview</h1>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((stat, index) => (
          <div key={index} className="bg-white p-6 rounded-lg shadow-md border-l-4 border-gold">
            <p className="text-gray-500 text-sm">{stat.name}</p>
            <p className="text-3xl font-bold text-gold-dark">{stat.value}</p>
          </div>
        ))}
      </div>

      {/* Recent Orders */}
      <div className="bg-white p-6 rounded-lg shadow-md mb-8">
        <h2 className="text-xl font-bold mb-4 text-gold-dark">Recent Orders</h2>
        <table className="w-full">
          <thead>
            <tr className="text-left text-gray-600 border-b">
              <th className="pb-2">Order ID</th>
              <th className="pb-2">Items</th>
              <th className="pb-2">Total</th>
              <th className="pb-2">Time</th>
            </tr>
          </thead>
          <tbody>
            {recentOrders.map(order => (
              <tr key={order.id} className="border-b">
                <td className="py-3">#{order.id}</td>
                <td>{order.items.length} items</td>

                <td>${order.total}</td>
                <td>
                  {order.orderedAt.toLocaleTimeString([], { 
                    hour: '2-digit', 
                    minute: '2-digit',
                    hour12: true 
                  })}
                </td>
              </tr>
            ))}
            {recentOrders.length === 0 && (
              <tr>
                <td colSpan="5" className="py-4 text-center text-gray-500">
                  No recent orders
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DashboardOverview;